import { IBuyPackageData } from '../../../../../../shared/slices/buyPackageModalSlice';
import { IBuyPackageHandlerData } from '../../../../../../shared/types/api';

/**
 * Преобразует поле serviceDurationInDays в durationInDays.
 */
export const normalizePackageData = (packageData: IBuyPackageHandlerData): IBuyPackageData => {
  const { services, ...rest } = packageData;

  return {
    ...rest,
    services: services.map(service => {
      const { durationInDays, serviceDurationInDays, ...restService } = service;

      return {
        ...restService,
        durationInDays: durationInDays ?? serviceDurationInDays,
      };
    }),
  };
};
